export const EXPONEA_BANNER = {
  type: 'normal',
  page: 'home',
};
